import { type AppearanceTypes } from './types';

export const DEFAULT_APPEARANCE: AppearanceTypes = 'normal';

export const flagWidth = 400;
